import React from 'react'
import Chart from 'react-apexcharts'
import {useThemeMode} from '../../../../../_metronic/partials'

const BarChart = ({
  fileTypesData,
}: {
  fileTypesData:
    | {
        audio: number | undefined
        excel: number | undefined
        others: number | undefined
        pdf: number | undefined
        ppt: number | undefined
        text: number | undefined
        videos: number | undefined
        wordDoc: number | undefined
      }
    | undefined
}) => {
  const {mode} = useThemeMode()
  const options: any = {
    series: [
      {
        name: 'Count',
        data: [
          fileTypesData?.pdf || 0,
          fileTypesData?.wordDoc || 0,
          fileTypesData?.excel || 0,
          fileTypesData?.videos || 0,
          fileTypesData?.audio || 0,
          fileTypesData?.text || 0,
          fileTypesData?.ppt || 0,
          fileTypesData?.others || 0,
        ],
      },
    ],
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        // borderRadiusApplication: 'end',
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ['Pdf', 'Word Doc', 'Excel', 'Video', 'Audio', 'Text', 'Ppt', 'Others'],
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    grid: {
      show: true,
      borderColor: mode === 'dark' ? '#565674' : '#DBDFE9',
      strokeDashArray: 0,
      position: 'back',
    },
  }

  return (
    <div id='chart'>
      <Chart options={options} series={options.series} type='bar' height={315} />
    </div>
  )
}

export default BarChart
